<template>
  <div v-loading="loading" class="birthday-stat-v3">
    <!-- 1. Header Phân Hệ Thống Kê Sinh Nhật & Bộ Lọc Tháng -->
    <div class="stat-section-header">
      <div class="header-left">
        <div class="section-icon-badge">
          <i class="el-icon-present"></i>
        </div>
        <div>
          <div class="title-with-pill">
            <h2 class="section-main-title">Thống Kê Sinh Nhật</h2>
            <span class="live-status-pill">
              <span class="pulse-dot"></span> Tháng {{ formattedMonthLabel }}
            </span>
          </div>
          <p class="section-subtitle">
            Theo dõi danh sách sinh nhật học sinh, phụ huynh và đội ngũ nhân sự trong tháng để kịp thời gửi lời chúc mừng
          </p>
        </div>
      </div>

      <!-- Bộ lọc theo Tháng chuyên dụng -->
      <div class="header-filters">
        <div class="month-filter-wrapper">
          <button
            type="button"
            class="month-nav-btn"
            title="Tháng trước"
            @click="changeMonth(-1)"
          >
            <i class="el-icon-arrow-left"></i>
          </button>

          <el-date-picker
            v-model="selectedMonth"
            type="month"
            size="small"
            format="MM/yyyy"
            value-format="yyyy-MM"
            placeholder="Chọn tháng"
            :clearable="false"
            class="birthday-month-picker"
            @change="handleMonthChange"
          />

          <button
            type="button"
            class="month-current-btn"
            @click="setCurrentMonth"
          >
            Tháng này
          </button>

          <button
            type="button"
            class="month-nav-btn"
            title="Tháng sau"
            @click="changeMonth(1)"
          >
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>

        <div v-if="overview" class="total-badge-chip">
          <i class="el-icon-bell"></i>
          <span>Tổng: <strong>{{ totalAllBirthdays }}</strong> sinh nhật</span>
        </div>
      </div>
    </div>

    <!-- 2. BA THẺ CHỈ SỐ KPI CHÍNH (Bấm vào để mở dialog chi tiết) -->
    <div v-if="error">
      <el-alert :title="error" type="error" show-icon :closable="false" />
      <el-button size="small" icon="el-icon-refresh" @click="loadMonth">Thử lại</el-button>
    </div>
    <div v-if="overview" class="birthday-kpi-grid">
      <!-- KPI 1: Sinh nhật học sinh -->
      <div
        class="birthday-kpi-card kpi-student"
        role="button"
        tabindex="0"
        @click="openDialog('student')"
        @keydown.enter="openDialog('student')"
      >
        <div class="kpi-top">
          <div class="kpi-icon-wrap bg-rose-subtle text-rose">
            <i class="el-icon-present"></i>
          </div>
          <span class="kpi-tag tag-rose">Học sinh</span>
        </div>
        <div class="kpi-body">
          <span class="kpi-label">Sinh Nhật Học Sinh</span>
          <div class="kpi-number-row">
            <strong class="kpi-value text-rose-dark">{{ overview.students.total }}</strong>
            <span class="kpi-unit">học sinh</span>
          </div>
          <p class="kpi-desc">
            {{ studentBoyCount }} nam • {{ studentGirlCount }} nữ<span v-if="overview.students.unknown"> • {{ overview.students.unknown }} chưa xác định</span> trong tháng {{ formattedMonthLabel }}
          </p>
        </div>
        <div class="kpi-footer-action text-rose">
          <span>Bấm xem danh sách chi tiết ({{ overview.students.total }})</span>
          <i class="el-icon-right"></i>
        </div>
        <div class="card-glow-bar glow-rose"></div>
      </div>

      <!-- KPI 2: Sinh nhật phụ huynh -->
      <div
        class="birthday-kpi-card kpi-parent"
        role="button"
        tabindex="0"
        @click="openDialog('parent')"
        @keydown.enter="openDialog('parent')"
      >
        <div class="kpi-top">
          <div class="kpi-icon-wrap bg-indigo-subtle text-indigo">
            <i class="el-icon-user"></i>
          </div>
          <span class="kpi-tag tag-indigo">Phụ huynh</span>
        </div>
        <div class="kpi-body">
          <span class="kpi-label">Sinh Nhật Phụ Huynh</span>
          <div class="kpi-number-row">
            <strong class="kpi-value text-indigo-dark">{{ overview.parents.total }}</strong>
            <span class="kpi-unit">phụ huynh</span>
          </div>
          <p class="kpi-desc">
            {{ parentFatherCount }} bố • {{ parentMotherCount }} mẹ<span v-if="overview.parents.unknown"> • {{ overview.parents.unknown }} chưa xác định</span> trong tháng {{ formattedMonthLabel }}
          </p>
        </div>
        <div class="kpi-footer-action text-indigo">
          <span>Bấm xem danh sách chi tiết ({{ overview.parents.total }})</span>
          <i class="el-icon-right"></i>
        </div>
        <div class="card-glow-bar glow-indigo"></div>
      </div>

      <!-- KPI 3: Sinh nhật nhân sự -->
      <div
        class="birthday-kpi-card kpi-employee"
        role="button"
        tabindex="0"
        @click="openDialog('employee')"
        @keydown.enter="openDialog('employee')"
      >
        <div class="kpi-top">
          <div class="kpi-icon-wrap bg-teal-subtle text-teal">
            <i class="el-icon-s-cooperation"></i>
          </div>
          <span class="kpi-tag tag-teal">Nhân sự</span>
        </div>
        <div class="kpi-body">
          <span class="kpi-label">Sinh Nhật Nhân Sự</span>
          <div class="kpi-number-row">
            <strong class="kpi-value text-teal-dark">{{ overview.employees.total }}</strong>
            <span class="kpi-unit">nhân sự</span>
          </div>
          <p class="kpi-desc">
            {{ employeeMaleCount }} nam • {{ employeeFemaleCount }} nữ<span v-if="overview.employees.unknown"> • {{ overview.employees.unknown }} chưa xác định</span> giáo viên & cán bộ
          </p>
        </div>
        <div class="kpi-footer-action text-teal">
          <span>Bấm xem danh sách chi tiết ({{ overview.employees.total }})</span>
          <i class="el-icon-right"></i>
        </div>
        <div class="card-glow-bar glow-teal"></div>
      </div>
    </div>

    <!-- 3. KHU VỰC BIỂU ĐỒ PHÂN BỐ & WIDGET LỊCH SINH NHẬT -->
    <el-row v-if="overview" :gutter="20" class="charts-row">
      <!-- 3.1 Biểu đồ Phân bố sinh nhật theo ngày trong tháng (ECharts) -->
      <el-col :xs="24" :lg="16">
        <div class="chart-card">
          <div class="chart-card-header">
            <div class="chart-title-group">
              <i class="el-icon-date chart-icon"></i>
              <div>
                <h3 class="chart-title">Phân Bố Ngày Sinh Nhật Trong Tháng {{ formattedMonthLabel }}</h3>
                <span class="chart-subtitle">Biểu đồ tổng hợp ngày sinh nhật của học sinh, phụ huynh và nhân sự</span>
              </div>
            </div>
            <div class="chart-legend-custom">
              <span class="legend-dot-item dot-rose">Học sinh ({{ overview.students.total }})</span>
              <span class="legend-dot-item dot-indigo">Phụ huynh ({{ overview.parents.total }})</span>
              <span class="legend-dot-item dot-teal">Nhân sự ({{ overview.employees.total }})</span>
            </div>
          </div>
          <div class="chart-body">
            <div ref="chartBirthdayTimeline" class="echart-box"></div>
          </div>
        </div>
      </el-col>

      <!-- 3.2 Widget Lịch Sinh Nhật Nổi Bật / Sắp Tới -->
      <el-col :xs="24" :lg="8">
        <div class="upcoming-card">
          <div class="upcoming-header">
            <div class="upcoming-title-wrap">
              <i class="el-icon-magic-stick text-rose"></i>
              <h3 class="upcoming-title">Sinh Nhật Sắp Tới</h3>
            </div>
            <span class="upcoming-badge">Tháng {{ formattedMonthLabel }}</span>
          </div>

          <div class="upcoming-list">
            <div
              v-for="item in upcomingBirthdays"
              :key="item.type + '-' + item.id"
              class="upcoming-item"
              :class="'type-' + item.type"
            >
              <div class="upcoming-avatar" :class="'avatar-' + item.type">
                <i :class="typeIcon(item.type)"></i>
              </div>
              <div class="upcoming-info">
                <div class="upcoming-name-row">
                  <span class="upcoming-name">{{ item.name }}</span>
                  <span :class="['upcoming-type-tag', 'tag-' + item.type]">
                    {{ typeLabel(item.type) }}
                  </span>
                </div>
                <div class="upcoming-meta">
                  <span class="meta-date">
                    <i class="el-icon-time"></i> {{ formatBirthDate(item.birthDate) }}
                  </span>
                  <span v-if="subInfo(item)" class="meta-sub">
                    <i class="el-icon-school"></i> {{ subInfo(item) }}
                  </span>
                </div>
              </div>
              <div class="upcoming-countdown">
                <span class="countdown-badge" :class="'badge-' + item.type">
                  Ngày {{ formatDayMonth(item.occurrenceDate) }}
                </span>
              </div>
            </div>
          </div>

          <div v-if="!upcomingBirthdays.length" class="upcoming-list">Không có sinh nhật sắp tới trong tháng này.</div>

          <div class="upcoming-footer">
            <button class="quick-view-all-btn" @click="openAllDialog">
              <i class="el-icon-search"></i> Tra cứu toàn bộ danh sách
            </button>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 4. DIALOG CHI TIẾT DANH SÁCH SINH NHẬT -->
    <el-dialog
      v-if="overview"
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="78%"
      top="5vh"
      custom-class="modern-birthday-dialog"
      :destroy-on-close="true"
      :close-on-click-modal="true"
    >
      <!-- Dialog Custom Header -->
      <div slot="title" class="dialog-custom-header">
        <div class="dialog-header-left">
          <div class="dialog-icon-badge" :class="dialogBadgeClass">
            <i :class="dialogIcon"></i>
          </div>
          <div>
            <h3 class="dialog-heading">{{ dialogTitle }}</h3>
            <p class="dialog-subheading">
              <i class="el-icon-date"></i> Tháng {{ formattedMonthLabel }} &nbsp;•&nbsp;
              <i class="el-icon-user"></i> Tìm thấy <strong>{{ filteredList.length }}</strong> đối tượng &nbsp;•&nbsp;
            </p>
          </div>
        </div>
      </div>

      <!-- Thanh chuyển đổi nhanh Tab đối tượng ngay trong Dialog -->
      <div class="dialog-toolbar">
        <div class="dialog-tabs">
          <button
            type="button"
            :class="['d-tab-btn', 'tab-student', { active: activeDialogType === 'student' }]"
            @click="switchDialogType('student')"
          >
            <i class="el-icon-present"></i> Học Sinh ({{ overview.students.total }})
          </button>
          <button
            type="button"
            :class="['d-tab-btn', 'tab-parent', { active: activeDialogType === 'parent' }]"
            @click="switchDialogType('parent')"
          >
            <i class="el-icon-user"></i> Phụ Huynh ({{ overview.parents.total }})
          </button>
          <button
            type="button"
            :class="['d-tab-btn', 'tab-employee', { active: activeDialogType === 'employee' }]"
            @click="switchDialogType('employee')"
          >
            <i class="el-icon-s-cooperation"></i> Nhân Sự ({{ overview.employees.total }})
          </button>
        </div>

        <!-- Bộ lọc & Tìm kiếm trong Dialog -->
        <div class="dialog-filters">
          <!-- Ô tìm kiếm theo họ tên -->
          <el-input
            v-model="dialogSearchText"
            size="small"
            placeholder="Tìm theo họ tên..."
            prefix-icon="el-icon-search"
            clearable
            class="dialog-search-input"
            @input="handleDialogFilterChange"
          />

          <!-- Lọc theo Khối (Chỉ hiển thị cho Học sinh & Phụ huynh) -->
          <el-select
            v-if="activeDialogType !== 'employee'"
            v-model="dialogGradeFilter"
            size="small"
            placeholder="Tất cả các khối"
            clearable
            class="dialog-select"
            @change="handleDialogFilterChange"
          >
            <el-option label="Tất cả các khối" value="" />
            <el-option v-for="grade in gradeOptions" :key="grade" :label="grade" :value="grade" />
          </el-select>

          <!-- Lọc theo giới tính hoặc vai trò phụ huynh -->
          <el-select
            v-model="dialogGenderFilter"
            size="small"
            :placeholder="activeDialogType === 'parent' ? 'Vai trò' : 'Giới tính'"
            clearable
            class="dialog-gender-select"
            @change="handleDialogFilterChange"
          >
            <el-option :label="activeDialogType === 'parent' ? 'Tất cả vai trò' : 'Tất cả giới tính'" value="" />
            <el-option v-if="activeDialogType === 'parent'" label="Bố" value="Bố" />
            <el-option v-if="activeDialogType === 'parent'" label="Mẹ" value="Mẹ" />
            <el-option v-if="activeDialogType !== 'parent'" label="Nam" value="Nam" />
            <el-option v-if="activeDialogType !== 'parent'" label="Nữ" value="Nữ" />
            <el-option label="Chưa xác định" value="Chưa xác định" />
          </el-select>

        </div>
      </div>

      <!-- BẢNG DỮ LIỆU ĐÚNG THEO YÊU CẦU CHO TỪNG ĐỐI TƯỢNG -->
      <div class="dialog-table-container">
        <!-- 1. BẢNG HỌC SINH: STT, Họ tên, Khối, Lớp, Giới tính, Ngày sinh -->
        <el-table
          v-if="activeDialogType === 'student'"
          :data="paginatedList"
          empty-text="Không có sinh nhật phù hợp"
          stripe
          border
          style="width: 100%"
          max-height="450"
          :header-cell-style="{ background: '#f8fafc', color: '#334155', fontWeight: '600' }"
          class="custom-birthday-table"
        >
          <!-- Cột STT -->
          <el-table-column
            label="STT"
            type="index"
            :index="calcIndex"
            align="center"
            width="70"
          />

          <!-- Cột Họ tên -->
          <el-table-column
            prop="name"
            label="Họ tên"
            min-width="180"
          >
            <template slot-scope="{ row }">
              <div class="name-cell">
                <div class="name-avatar" :class="row.gender === 'Nam' ? 'avatar-boy' : 'avatar-girl'">
                  <i :class="row.gender === 'Nam' ? 'el-icon-user' : 'el-icon-user-solid'"></i>
                </div>
                <div class="name-text">
                  <span class="full-name">{{ row.name }}</span>
                  <span v-if="isTodayBirthday(row.occurrenceDate)" class="today-birthday-badge">
                    🎂 Hôm nay
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- Cột Khối -->
          <el-table-column
            prop="gradeName"
            label="Khối"
            width="140"
          >
            <template slot-scope="{ row }">
              <span class="grade-cell-tag">{{ row.gradeName }}</span>
            </template>
          </el-table-column>

          <!-- Cột Lớp -->
          <el-table-column
            prop="className"
            label="Lớp"
            width="150"
          >
            <template slot-scope="{ row }">
              <el-tag size="small" type="info" class="class-pill">
                {{ row.className }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- Cột Giới tính -->
          <el-table-column
            prop="gender"
            label="Giới tính"
            align="center"
            width="110"
          >
            <template slot-scope="{ row }">
              <el-tag
                size="mini"
                :type="genderTagType(row.gender)"
                class="gender-tag"
              >
                {{ row.gender }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- Cột Ngày sinh -->
          <el-table-column
            prop="birthDate"
            label="Ngày sinh"
            align="center"
            width="140"
          >
            <template slot-scope="{ row }">
              <span class="birthdate-tag">
                <i class="el-icon-date"></i> {{ formatBirthDate(row.birthDate) }}
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 2. BẢNG PHỤ HUYNH: STT, Họ tên, Tên học sinh, Khối, Lớp, Giới tính, Ngày sinh -->
        <el-table
          v-else-if="activeDialogType === 'parent'"
          :data="paginatedList"
          empty-text="Không có sinh nhật phù hợp"
          stripe
          border
          style="width: 100%"
          max-height="450"
          :header-cell-style="{ background: '#f8fafc', color: '#334155', fontWeight: '600' }"
          class="custom-birthday-table"
        >
          <!-- Cột STT -->
          <el-table-column
            label="STT"
            type="index"
            :index="calcIndex"
            align="center"
            width="70"
          />

          <!-- Cột Họ tên (Phụ huynh) -->
          <el-table-column
            prop="name"
            label="Họ tên"
            min-width="170"
          >
            <template slot-scope="{ row }">
              <div class="name-cell">
                <div class="name-avatar avatar-parent">
                  <i class="el-icon-user"></i>
                </div>
                <div class="name-text">
                  <span class="full-name">{{ row.name }}</span><span v-if="row.childCount > 1"> và {{ row.childCount - 1 }} con khác</span>
                  <span v-if="isTodayBirthday(row.occurrenceDate)" class="today-birthday-badge">
                    🎂 Hôm nay
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- Cột Tên học sinh -->
          <el-table-column
            prop="studentName"
            label="Tên học sinh"
            min-width="170"
          >
            <template slot-scope="{ row }">
              <span class="student-link">
                <i class="el-icon-link"></i> {{ row.studentName }}
              </span>
            </template>
          </el-table-column>

          <!-- Cột Khối -->
          <el-table-column
            prop="gradeName"
            label="Khối"
            width="130"
          >
            <template slot-scope="{ row }">
              <span class="grade-cell-tag">{{ row.gradeName }}</span>
            </template>
          </el-table-column>

          <!-- Cột Lớp -->
          <el-table-column
            prop="className"
            label="Lớp"
            width="140"
          >
            <template slot-scope="{ row }">
              <el-tag size="small" type="info" class="class-pill">
                {{ row.className }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- Cột vai trò phụ huynh -->
          <el-table-column
            prop="relation"
            label="Vai trò"
            align="center"
            width="110"
          >
            <template slot-scope="{ row }">
              <el-tag
                size="mini"
                :type="row.relation === 'Bố' ? 'primary' : row.relation === 'Mẹ' ? 'danger' : 'info'"
                class="gender-tag"
              >
                {{ row.relation }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- Cột Ngày sinh -->
          <el-table-column
            prop="birthDate"
            label="Ngày sinh"
            align="center"
            width="140"
          >
            <template slot-scope="{ row }">
              <span class="birthdate-tag">
                <i class="el-icon-date"></i> {{ formatBirthDate(row.birthDate) }}
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 3. BẢNG NHÂN SỰ: STT, Họ tên, Giới tính, Ngày sinh -->
        <el-table
          v-else-if="activeDialogType === 'employee'"
          :data="paginatedList"
          empty-text="Không có sinh nhật phù hợp"
          stripe
          border
          style="width: 100%"
          max-height="450"
          :header-cell-style="{ background: '#f8fafc', color: '#334155', fontWeight: '600' }"
          class="custom-birthday-table"
        >
          <!-- Cột STT -->
          <el-table-column
            label="STT"
            type="index"
            :index="calcIndex"
            align="center"
            width="70"
          />

          <!-- Cột Họ tên (Nhân sự) -->
          <el-table-column
            prop="name"
            label="Họ tên"
            min-width="220"
          >
            <template slot-scope="{ row }">
              <div class="name-cell">
                <div class="name-avatar avatar-employee">
                  <i class="el-icon-s-custom"></i>
                </div>
                <div class="name-text">
                  <span class="full-name">{{ row.name }}</span>
                  <span class="emp-role-tag">{{ row.roleTitle }}</span>
                  <span v-if="isTodayBirthday(row.occurrenceDate)" class="today-birthday-badge">
                    🎂 Hôm nay
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- Cột Giới tính -->
          <el-table-column
            prop="gender"
            label="Giới tính"
            align="center"
            width="120"
          >
            <template slot-scope="{ row }">
              <el-tag
                size="mini"
                :type="genderTagType(row.gender)"
                class="gender-tag"
              >
                {{ row.gender }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- Cột Ngày sinh -->
          <el-table-column
            prop="birthDate"
            label="Ngày sinh"
            align="center"
            width="160"
          >
            <template slot-scope="{ row }">
              <span class="birthdate-tag">
                <i class="el-icon-date"></i> {{ formatBirthDate(row.birthDate) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Phân trang trong Dialog -->
      <div class="dialog-pagination-bar">
        <span class="pagination-info">
          Hiển thị <strong>{{ filteredList.length ? (currentPage - 1) * pageSize + 1 : 0 }}</strong> -
          <strong>{{ Math.min(currentPage * pageSize, filteredList.length) }}</strong>
          trên tổng số <strong>{{ filteredList.length }}</strong> người
        </span>

        <el-pagination
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="filteredList.length"
          layout="prev, pager, next"
          background
        />
      </div>

      <!-- Footer Dialog -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">Đóng</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import BirthdayStatisticsService from "@/services/dashboard_v3/BirthdayStatisticsService";

const schoolMonth = () => moment().utcOffset(420).format("YYYY-MM");

export default {
  name: "BirthdayStatisticsV3",
  props: {
    autoLoad: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hasLoadedData: false,
      isLoadingData: false,
      selectedMonth: schoolMonth(),
      overview: null,
      loading: false,
      error: "",
      requestVersion: 0,
      dialogVisible: false,
      activeDialogType: "student",
      dialogSearchText: "",
      dialogGradeFilter: "",
      dialogGenderFilter: "",
      currentPage: 1,
      pageSize: 10,
      chartTimeline: null
    };
  },
  computed: {
    formattedMonthLabel() {
      return moment(this.selectedMonth, "YYYY-MM").format("MM/YYYY");
    },
    studentList() {
      return this.overview ? this.overview.studentList : [];
    },
    parentList() {
      return this.overview ? this.overview.parentList : [];
    },
    employeeList() {
      return this.overview ? this.overview.employeeList : [];
    },
    totalAllBirthdays() {
      return this.overview ? this.overview.total : 0;
    },
    studentBoyCount() {
      return this.overview ? this.overview.students.male : 0;
    },
    studentGirlCount() {
      return this.overview ? this.overview.students.female : 0;
    },
    parentFatherCount() {
      return this.overview ? this.overview.parents.male : 0;
    },
    parentMotherCount() {
      return this.overview ? this.overview.parents.female : 0;
    },
    employeeMaleCount() {
      return this.overview ? this.overview.employees.male : 0;
    },
    employeeFemaleCount() {
      return this.overview ? this.overview.employees.female : 0;
    },
    upcomingBirthdays() {
      return this.overview ? this.overview.upcoming : [];
    },
    gradeOptions() {
      const list = this.activeDialogType === "parent" ? this.parentList : this.studentList;
      const grades = this.activeDialogType === "parent"
        ? list.reduce((all, person) => all.concat(person.gradeNames || []), [])
        : list.map(person => person.gradeName);
      return [...new Set(grades.filter(Boolean))].sort();
    },
    dialogTitle() {
      const names = { student: "Học Sinh", parent: "Phụ Huynh", employee: "Nhân Sự" };
      return "Danh Sách Sinh Nhật " + names[this.activeDialogType] + " (Tháng " + this.formattedMonthLabel + ")";
    },
    dialogIcon() {
      return this.typeIcon(this.activeDialogType);
    },
    dialogBadgeClass() {
      return { student: "badge-rose", parent: "badge-indigo", employee: "badge-teal" }[this.activeDialogType];
    },
    filteredList() {
      const list = this.activeDialogType === "student" ? this.studentList
        : this.activeDialogType === "parent" ? this.parentList : this.employeeList;
      const q = this.dialogSearchText.trim().toLocaleLowerCase("vi");
      return list.filter(person =>
        (!q || (person.name || "").toLocaleLowerCase("vi").includes(q)
          || (person.studentName || "").toLocaleLowerCase("vi").includes(q))
        && (!this.dialogGradeFilter || (this.activeDialogType === "parent"
          ? (person.gradeNames || []).includes(this.dialogGradeFilter)
          : person.gradeName === this.dialogGradeFilter))
        && (!this.dialogGenderFilter || (this.activeDialogType === "parent"
          ? person.relation === this.dialogGenderFilter : person.gender === this.dialogGenderFilter))
      );
    },
    paginatedList() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredList.slice(start, start + this.pageSize);
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    if (this.autoLoad) {
      this.loadData();
    }
  },
  beforeDestroy() {
    this.requestVersion++;
    window.removeEventListener("resize", this.handleResize);
    this.disposeChart();
  },
  methods: {
    async loadData() {
      if (this.hasLoadedData || this.isLoadingData) return;
      this.isLoadingData = true;
      try {
        await this.loadMonth();
        this.hasLoadedData = true;
      } finally {
        this.isLoadingData = false;
      }
    },
    async loadMonth() {
      const version = ++this.requestVersion;
      const month = this.selectedMonth;
      this.disposeChart();
      this.overview = null;
      this.dialogVisible = false;
      this.loading = true;
      this.error = "";
      try {
        const response = await BirthdayStatisticsService.getMonthly(month);
        if (version !== this.requestVersion) return;
        const data = response && response.data && response.data.data;
        if (!data || data.month !== month || !Array.isArray(data.days)
            || !Array.isArray(data.studentList) || !Array.isArray(data.parentList)
            || !Array.isArray(data.employeeList) || !Array.isArray(data.upcoming)) {
          throw new Error("Dữ liệu sinh nhật không hợp lệ");
        }
        this.overview = data;
        this.$nextTick(this.renderTimelineChart);
      } catch (error) {
        if (version !== this.requestVersion) return;
        this.error = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message : "Không tải được thống kê sinh nhật. Vui lòng thử lại.";
      } finally {
        if (version === this.requestVersion) this.loading = false;
      }
    },
    changeMonth(step) {
      this.selectedMonth = moment(this.selectedMonth, "YYYY-MM").add(step, "months").format("YYYY-MM");
      this.handleMonthChange();
    },
    setCurrentMonth() {
      this.selectedMonth = schoolMonth();
      this.handleMonthChange();
    },
    handleMonthChange() {
      this.currentPage = 1;
      this.loadMonth();
    },
    openDialog(type) {
      if (!this.overview) return;
      this.switchDialogType(type);
      this.dialogVisible = true;
    },
    openAllDialog() {
      const type = this.studentList.length ? "student" : this.parentList.length ? "parent" : "employee";
      this.openDialog(type);
    },
    switchDialogType(type) {
      this.activeDialogType = type;
      this.dialogSearchText = "";
      this.dialogGradeFilter = "";
      this.dialogGenderFilter = "";
      this.currentPage = 1;
    },
    handleDialogFilterChange() {
      this.currentPage = 1;
    },
    calcIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    formatBirthDate(date) {
      return date ? moment(date, "YYYY-MM-DD").format("DD/MM/YYYY") : "—";
    },
    formatDayMonth(date) {
      return date ? moment(date, "YYYY-MM-DD").format("DD/MM") : "—";
    },
    isTodayBirthday(occurrenceDate) {
      return !!(this.overview && occurrenceDate === this.overview.asOfDate);
    },
    typeIcon(type) {
      return { student: "el-icon-present", parent: "el-icon-user", employee: "el-icon-s-cooperation" }[type];
    },
    typeLabel(type) {
      return { student: "Học sinh", parent: "Phụ huynh", employee: "Nhân sự" }[type];
    },
    genderTagType(gender) {
      return gender === "Nam" ? "primary" : gender === "Nữ" ? "danger" : "info";
    },
    subInfo(person) {
      if (person.type === "student") return person.className || "";
      if (person.type === "parent") {
        return "PH con: " + (person.studentName || "")
          + (person.childCount > 1 ? " và " + (person.childCount - 1) + " con khác" : "");
      }
      return person.roleTitle || "";
    },
    handleResize() {
      if (this.chartTimeline) this.chartTimeline.resize();
    },
    disposeChart() {
      if (this.chartTimeline) {
        this.chartTimeline.dispose();
        this.chartTimeline = null;
      }
    },
    renderTimelineChart() {
      const dom = this.$refs.chartBirthdayTimeline;
      if (!dom || !this.overview) return;
      this.disposeChart();
      this.chartTimeline = echarts.init(dom);
      const days = this.overview.days;
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(15, 23, 42, 0.9)",
          borderColor: "#334155",
          textStyle: { color: "#f8fafc", fontSize: 12 }
        },
        grid: { left: "2%", right: "2%", top: "14%", bottom: "4%", containLabel: true },
        xAxis: {
          type: "category",
          data: days.map(point => "N." + moment(point.date, "YYYY-MM-DD").format("DD")),
          axisLine: { lineStyle: { color: "#cbd5e1" } },
          axisLabel: { color: "#64748b", fontSize: 11, interval: 1 }
        },
        yAxis: {
          type: "value", name: "Số người", minInterval: 1,
          nameTextStyle: { color: "#94a3b8", fontSize: 11 },
          splitLine: { lineStyle: { type: "dashed", color: "#f1f5f9" } },
          axisLabel: { color: "#64748b", fontSize: 11 }
        },
        series: [
          { name: "Học sinh", type: "bar", stack: "total", barWidth: 14,
            itemStyle: { color: "#f43f5e" }, data: days.map(point => point.students) },
          { name: "Phụ huynh", type: "bar", stack: "total", barWidth: 14,
            itemStyle: { color: "#6366f1" }, data: days.map(point => point.parents) },
          { name: "Nhân sự", type: "bar", stack: "total", barWidth: 14,
            itemStyle: { color: "#0d9488", borderRadius: [3, 3, 0, 0] },
            data: days.map(point => point.employees) }
        ]
      };
      this.chartTimeline.setOption(option);
    }
  }
};
</script>

<style scoped>
/* Container Phân hệ Thống Kê Sinh Nhật V3 */
.birthday-stat-v3 {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05), 0 2px 6px -1px rgba(15, 23, 42, 0.02);
  margin-bottom: 24px;
}

/* 1. Header & Bộ Lọc */
.stat-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.section-icon-badge {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f43f5e, #fb7185);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(244, 63, 94, 0.3);
}

.title-with-pill {
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-main-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.02em;
}

.live-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 9999px;
  background: #fff1f2;
  color: #e11d48;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #ffe4e6;
}

.pulse-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #e11d48;
  box-shadow: 0 0 0 3px rgba(225, 29, 72, 0.25);
  animation: pulse-ring 1.8s infinite;
}

@keyframes pulse-ring {
  0% { transform: scale(0.9); box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.5); }
  70% { transform: scale(1); box-shadow: 0 0 0 6px rgba(225, 29, 72, 0); }
  100% { transform: scale(0.9); box-shadow: 0 0 0 0 rgba(225, 29, 72, 0); }
}

.section-subtitle {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #64748b;
}

/* Header Filters */
.header-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.month-filter-wrapper {
  display: inline-flex;
  align-items: center;
  background: #f8fafc;
  padding: 3px 4px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.month-nav-btn {
  border: none;
  background: transparent;
  color: #64748b;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
}

.month-nav-btn:hover {
  background: #ffffff;
  color: #e11d48;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.month-current-btn {
  border: none;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  padding: 0 8px;
  height: 30px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.month-current-btn:hover {
  background: #ffffff;
  color: #0f172a;
}

.birthday-month-picker {
  width: 145px !important;
}

.birthday-month-picker >>> .el-input__inner {
  border: none !important;
  background: transparent !important;
  font-weight: 600 !important;
  color: #0f172a !important;
  padding-left: 28px !important;
  padding-right: 0 !important;
}

.total-badge-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 10px;
  background: #fff7ed;
  border: 1px solid #ffedd5;
  color: #c2410c;
  font-size: 12.5px;
}

/* 2. 3 Thẻ Chỉ Số KPI */
.birthday-kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-bottom: 24px;
}

@media (max-width: 992px) {
  .birthday-kpi-grid {
    grid-template-columns: 1fr;
  }
}

.birthday-kpi-card {
  position: relative;
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 14px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03);
}

.birthday-kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px -4px rgba(15, 23, 42, 0.1);
}

.kpi-student:hover {
  border-color: #fca5a5;
  background: linear-gradient(180deg, #fff5f5 0%, #ffffff 100%);
}

.kpi-parent:hover {
  border-color: #a5b4fc;
  background: linear-gradient(180deg, #f5f3ff 0%, #ffffff 100%);
}

.kpi-employee:hover {
  border-color: #99f6e4;
  background: linear-gradient(180deg, #f0fdfa 0%, #ffffff 100%);
}

.kpi-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.kpi-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.bg-rose-subtle { background: #ffe4e6; }
.text-rose { color: #f43f5e; }
.text-rose-dark { color: #e11d48; }
.tag-rose { background: #fff1f2; color: #e11d48; border: 1px solid #fecdd3; }

.bg-indigo-subtle { background: #e0e7ff; }
.text-indigo { color: #6366f1; }
.text-indigo-dark { color: #4f46e5; }
.tag-indigo { background: #eef2ff; color: #4f46e5; border: 1px solid #c7d2fe; }

.bg-teal-subtle { background: #ccfbf1; }
.text-teal { color: #0d9488; }
.text-teal-dark { color: #0f766e; }
.tag-teal { background: #f0fdfa; color: #0f766e; border: 1px solid #99f6e4; }

.kpi-tag {
  font-size: 11.5px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
}

.kpi-label {
  font-size: 13.5px;
  color: #64748b;
  font-weight: 500;
}

.kpi-number-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 6px 0 4px 0;
}

.kpi-value {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.02em;
}

.kpi-unit {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.kpi-desc {
  margin: 0;
  font-size: 12.5px;
  color: #94a3b8;
}

.kpi-footer-action {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px dashed #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12.5px;
  font-weight: 600;
}

.card-glow-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
}

.glow-rose { background: linear-gradient(90deg, #f43f5e, #fb7185); }
.glow-indigo { background: linear-gradient(90deg, #6366f1, #818cf8); }
.glow-teal { background: linear-gradient(90deg, #0d9488, #2dd4bf); }

/* 3. Khu Vực Biểu Đồ & Widget */
.charts-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.charts-row::before,
.charts-row::after {
  display: none;
}

.charts-row > .el-col {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.chart-card,
.upcoming-card {
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.02);
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.chart-card-header,
.upcoming-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f8fafc;
}

.chart-title-group,
.upcoming-title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chart-icon {
  font-size: 20px;
  color: #f43f5e;
}

.chart-title,
.upcoming-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.chart-subtitle {
  font-size: 12px;
  color: #94a3b8;
}

.chart-legend-custom {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #64748b;
  align-items: center;
}

.legend-dot-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.legend-dot-item::before {
  content: "";
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
}

.dot-rose::before { background-color: #f43f5e; }
.dot-indigo::before { background-color: #6366f1; }
.dot-teal::before { background-color: #0d9488; }

.chart-body {
  flex: 1;
  min-height: 280px;
}

.echart-box {
  width: 100%;
  height: 280px;
}

/* Upcoming Widget */
.upcoming-badge {
  font-size: 12px;
  font-weight: 600;
  color: #e11d48;
  background: #fff1f2;
  padding: 3px 8px;
  border-radius: 6px;
}

.upcoming-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

.upcoming-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.upcoming-item:hover {
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
  border-color: #e2e8f0;
}

.upcoming-avatar {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.avatar-student { background: #ffe4e6; color: #f43f5e; }
.avatar-parent { background: #e0e7ff; color: #6366f1; }
.avatar-employee { background: #ccfbf1; color: #0d9488; }

.upcoming-info {
  flex: 1;
  min-width: 0;
}

.upcoming-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.upcoming-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.upcoming-type-tag {
  font-size: 10.5px;
  padding: 1px 6px;
  border-radius: 4px;
}

.upcoming-meta {
  display: flex;
  gap: 8px;
  font-size: 11.5px;
  color: #64748b;
  margin-top: 2px;
}

.countdown-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  white-space: nowrap;
}

.badge-student { background: #fff1f2; color: #e11d48; }
.badge-parent { background: #eef2ff; color: #4338ca; }
.badge-employee { background: #f0fdfa; color: #0f766e; }

.upcoming-footer {
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid #f8fafc;
}

.quick-view-all-btn {
  width: 100%;
  border: 1px dashed #cbd5e1;
  background: transparent;
  color: #475569;
  font-size: 12.5px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.quick-view-all-btn:hover {
  background: #f8fafc;
  color: #f43f5e;
  border-color: #fca5a5;
}

/* 4. MODAL DIALOG CHI TIẾT */
.modern-birthday-dialog >>> .el-dialog {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);
}

.modern-birthday-dialog >>> .el-dialog__header {
  padding: 20px 24px;
  background: #ffffff;
  border-bottom: 1px solid #f1f5f9;
}

.modern-birthday-dialog >>> .el-dialog__body {
  padding: 20px 24px;
  background: #fbfcfd;
}

.modern-birthday-dialog >>> .el-dialog__footer {
  padding: 16px 24px;
  background: #ffffff;
  border-top: 1px solid #f1f5f9;
}

.dialog-custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.dialog-icon-badge {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.badge-rose { background: #ffe4e6; color: #f43f5e; }
.badge-indigo { background: #e0e7ff; color: #6366f1; }
.badge-teal { background: #ccfbf1; color: #0d9488; }

.dialog-heading {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.dialog-subheading {
  font-size: 12.5px;
  color: #64748b;
  margin: 4px 0 0 0;
}

/* Toolbar trong Dialog */
.dialog-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
}

.dialog-tabs {
  display: flex;
  gap: 8px;
  background: #f1f5f9;
  padding: 4px;
  border-radius: 10px;
}

.d-tab-btn {
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.d-tab-btn.active.tab-student {
  background: #ffffff;
  color: #e11d48;
  box-shadow: 0 2px 6px rgba(225, 29, 72, 0.15);
}

.d-tab-btn.active.tab-parent {
  background: #ffffff;
  color: #4f46e5;
  box-shadow: 0 2px 6px rgba(79, 70, 229, 0.15);
}

.d-tab-btn.active.tab-employee {
  background: #ffffff;
  color: #0f766e;
  box-shadow: 0 2px 6px rgba(15, 118, 110, 0.15);
}

.dialog-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.dialog-search-input {
  width: 190px !important;
}

.dialog-select {
  width: 150px !important;
}

.dialog-gender-select {
  width: 120px !important;
}

.export-btn {
  background: #10b981 !important;
  border-color: #10b981 !important;
  font-weight: 600;
}

/* Bảng dữ liệu trong Dialog */
.dialog-table-container {
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.custom-birthday-table >>> .el-table__header th {
  font-size: 13px;
  letter-spacing: 0.01em;
}

.custom-birthday-table >>> .el-table__body td {
  padding: 10px 0;
  font-size: 13px;
}

.name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name-avatar {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.avatar-boy { background: #eff6ff; color: #2563eb; }
.avatar-girl { background: #fdf2f8; color: #db2777; }
.avatar-parent { background: #eef2ff; color: #6366f1; }
.avatar-employee { background: #f0fdfa; color: #0d9488; }

.name-text {
  display: flex;
  flex-direction: column;
}

.full-name {
  font-weight: 600;
  color: #0f172a;
}

.today-birthday-badge {
  font-size: 11px;
  color: #e11d48;
  font-weight: 600;
}

.emp-role-tag {
  font-size: 11px;
  color: #64748b;
}

.grade-cell-tag {
  font-weight: 500;
  color: #334155;
}

.class-pill {
  font-weight: 500;
  border-radius: 6px;
}

.student-link {
  font-weight: 600;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.gender-tag {
  font-weight: 600;
  border-radius: 4px;
  padding: 2px 8px;
}

.birthdate-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #0f172a;
  background: #f8fafc;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

/* Pagination trong Dialog */
.dialog-pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 12px;
}

.pagination-info {
  font-size: 12.5px;
  color: #64748b;
}
</style>
